import { render, staticRenderFns } from "./CellRenderCampaignName.vue?vue&type=template&id=107878c4&scoped=true&"
var script = {}
import style0 from "./CellRenderCampaignName.vue?vue&type=style&index=0&id=107878c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107878c4",
  null
  
)

export default component.exports